module.exports = __webpack_public_path__ + "img/login-img-zx.b60d5b00.png";